import React from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import { openModal } from 'bento-ordering/base/actions/modal';
import Box from '@mui/material/Box';
import { push } from 'connected-react-router';
import Typography from '@mui/material/Typography';
import SecondaryCta from 'components/Buttons/SecondaryCta';
import {
  SPENDING_LIMIT_PER_PERSON,
  DUE_BY
} from 'bento-ordering/group_ordering/constants/groupOrder';
import {
  GROUP_ORDERING_DEADLINE_INPUT_FORMAT,
  GROUP_ORDERING_DEADLINE_OUTPUT_FORMAT
} from 'bento-ordering/base/constants/timeFormat';
import { formatDateTime } from 'bento-ordering/base/utils/timeHelpers';
import { getValueWithTwoDecimalPlace } from 'helpers/formattedDollar';
import { ITEM_DESCRIPTION_AND_PRICES } from 'styles/constants/appearanceSectionNames';
import { StyledTypographyColorSectionNavLinkMainMedium } from 'components/StyledTypographyColorSectionNavLinkMainMedium';
import { getOwnCartDrawerState } from 'styles/helpers/getSecondaryButtonState';
import { generatePath } from 'bento-ordering/utils/generatePath';
import { GROUP_ORDER } from 'bento-ordering/group_ordering/constants/entities';

const CartGroupOrderInfo = ({
  groupOrderSpendingLimit = '',
  groupOrderDeadline = null,
  isGroupOrderAdminDiner
}) => {
  const dispatch = useDispatch();
  const handleOpenGroupOrderSettingsModal = () => {
    const path = generatePath(GROUP_ORDER, 'groupOrderSettings');

    dispatch(openModal());
    dispatch(push(path));
  };
  return (
    <Box
      data-testid="group-order-info"
      width="100%"
      mb={2}
      display="flex"
      flexDirection="row"
      alignItems="center"
    >
      {groupOrderSpendingLimit && (
        <Box display="inline-block" mt={1} mr={2.5}>
          <StyledTypographyColorSectionNavLinkMainMedium
            sx={{ display: 'block' }}
            variant={ITEM_DESCRIPTION_AND_PRICES}
          >
            {SPENDING_LIMIT_PER_PERSON}
          </StyledTypographyColorSectionNavLinkMainMedium>
          <Typography variant={ITEM_DESCRIPTION_AND_PRICES}>
            {`$${getValueWithTwoDecimalPlace(groupOrderSpendingLimit)}`}
          </Typography>
        </Box>
      )}
      {groupOrderDeadline && (
        <Box display="inline-block" mt={1} mr={2.5}>
          <StyledTypographyColorSectionNavLinkMainMedium
            sx={{ display: 'block' }}
            variant={ITEM_DESCRIPTION_AND_PRICES}
          >
            {DUE_BY}
          </StyledTypographyColorSectionNavLinkMainMedium>
          <Typography variant={ITEM_DESCRIPTION_AND_PRICES}>
            {formatDateTime(
              groupOrderDeadline,
              GROUP_ORDERING_DEADLINE_INPUT_FORMAT,
              GROUP_ORDERING_DEADLINE_OUTPUT_FORMAT
            )}
          </Typography>
          {isGroupOrderAdminDiner && (
            <Box position="relative">
              <SecondaryCta
                handleClick={handleOpenGroupOrderSettingsModal}
                label="Change"
                dataTestId="change-deadline"
                ownState={getOwnCartDrawerState()}
              />
            </Box>
          )}
        </Box>
      )}
    </Box>
  );
};

CartGroupOrderInfo.propTypes = {
  groupOrderSpendingLimit: PropTypes.string,
  groupOrderDeadline: PropTypes.string,
  isGroupOrderAdminDiner: PropTypes.bool.isRequired
};

export default CartGroupOrderInfo;
